import { FunctionComponent } from "react";

import { classNames } from "@/utils/classNames";

import { Tabs } from "./tabs";

interface GlobalSearchTabsBarProps {
	currentTab: Tabs;
	onTabChange: (tab: Tabs) => void;
}

/** The modal's "By name | By search filters | By LinkedIn URL" tab strip. */
export const GlobalSearchTabsBar: FunctionComponent<GlobalSearchTabsBarProps> = ({
	currentTab,
	onTabChange,
}) => {
	return (
		<div className="flex border-b border-gray-400">
			{[
				{ label: "By name", value: Tabs.BY_NAME },
				{ label: "By search filters", value: Tabs.BY_FILTERS },
				{ label: "By LinkedIn URL", value: Tabs.BY_URL },
			].map((tab) => (
				<button
					key={tab.value}
					className={classNames(
						"px-4 py-2.5 text-sm border-b-2 -mb-px transition-colors",
						currentTab === tab.value
							? "border-blue-500 text-blue-600 font-medium"
							: "border-transparent text-gray-500 hover:text-gray-700"
					)}
					onClick={() => onTabChange(tab.value)}
				>
					{tab.label}
				</button>
			))}
		</div>
	);
};
